import React from 'react';
import { BrowserRouter as Router, Routes, Route, useSearchParams } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import ChartView from './components/ChartView';
import IntegrationGuide from './components/IntegrationGuide';
import './App.css';
import './components/Dashboard.css';

const MainRoute: React.FC = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session');
  
  // If there's a session parameter, show the chart view, otherwise show dashboard
  return sessionId ? <ChartView /> : <Dashboard />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainRoute />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/integration" element={<IntegrationGuide />} />
        <Route path="*" element={<MainRoute />} />
      </Routes>
    </Router>
  );
}

export default App;